import { render, staticRenderFns } from "./EmarScheduledTreatmentEventsV1.vue?vue&type=template&id=ba143fd2&scoped=true&"
import script from "./EmarScheduledTreatmentEventsV1.vue?vue&type=script&lang=js&"
export * from "./EmarScheduledTreatmentEventsV1.vue?vue&type=script&lang=js&"
import style0 from "./EmarScheduledTreatmentEventsV1.vue?vue&type=style&index=0&id=ba143fd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba143fd2",
  null
  
)

export default component.exports